import { useHistory, Redirect } from 'react-router-dom'

import { Auth } from '@scouts/auth'
import { getIsMobileAppMode } from '@taxfix/scouts-helpers'
import { ButtonLink, Flexer } from '@taxfix/scouts-ui'

import { PATH_LOGIN, PATH_SIGNUP } from '@/constants'

const Footer = () => {
    const history = useHistory()

    return (
        <Flexer column gap="12px" alignCenter>
            <ButtonLink onClick={() => history.push(PATH_LOGIN)}>Already have an account? Log in here</ButtonLink>
            <ButtonLink onClick={() => history.push(PATH_SIGNUP)}>Sign up with email instead</ButtonLink>
        </Flexer>
    )
}

/**
 * Dedicated view for users coming from our website,
 * in order to support MFA and offer "agree to terms" checkboxes.
 */
export const SignupGoogle = () => {
    // Google OAuth is unavailable in mobile apps. Redirect to usual signup.
    const isMobileAppMode = getIsMobileAppMode()
    if (isMobileAppMode) {
        return <Redirect to={PATH_SIGNUP} />
    }

    return (
        <Auth.LockscreenLayout title="Let's get started" footer={<Footer />}>
            <Auth.SignupForm.Google />
        </Auth.LockscreenLayout>
    )
}
